import { createCrudHooks } from './base'
import type { Consumption, InsertConsumption } from '@markku/types'

export const consumptionHooks = createCrudHooks<
  Consumption,
  Consumption,
  InsertConsumption,
  Partial<InsertConsumption>
>('consumption')
